import { accountApi } from "../../config/apiConfig";
import { HubSettings } from "../../types/onboarding";

// The customer-portal address that goes into every configuration email
// (CWA-91). Stored server-side so the team can switch between the test and
// production portal without a deployment.

// GET /admin/config/hub-settings
export const getHubSettings = async (): Promise<HubSettings> => {
  const response = await accountApi.get("admin/config/hub-settings");
  return response.data;
};

// PUT /admin/config/hub-settings — same shape in and out. The backend does not
// validate the URL format, so the caller must.
export const updateHubSettings = async (
  payload: HubSettings
): Promise<HubSettings> => {
  const response = await accountApi.put("admin/config/hub-settings", payload);
  return response.data;
};
